import React, {useMemo} from 'react'
import {Global} from '@emotion/react'
import {useLocation} from 'react-router-dom'
import {useBreakpointValue} from '@salesforce/retail-react-app/app/components/shared/ui'

const ThirdPartyGlobalStyles = () => {
    const location = useLocation()
    const isDesktop = useBreakpointValue({base: false, lg: true})
    const isPDP = /\/p\//.test(location.pathname)

    // Memoized so Emotion doesn't re-serialize this on every render of the app root.
    const thirdPartyStyles = useMemo(
        () => ({
            '.grecaptcha-badge': {
                visibility: 'hidden'
            },
            '#embeddedMessagingConversationButton': {
                zIndex: '9999 !important'
            },
            '#embeddedMessagingFrame': {
                bottom: isDesktop ? '12px !important' : '0 !important',
                right: isDesktop ? '24px !important' : '0 !important',
                zIndex: '9999 !important'
            },
            '.embeddedMessagingConversationButton': {
                bottom: isPDP ? '118px !important' : '12px !important',
                right: isDesktop ? '24px !important' : '16px !important',
                zIndex: '9999 !important'
            }
        }),
        [isDesktop, isPDP]
    )

    return <Global styles={thirdPartyStyles} />
}

export {ThirdPartyGlobalStyles}
